import React from 'react';

const steps = [
  { id: 1, name: 'Business', label: 'Business' },
  { id: 2, name: 'Principal', label: 'Principal' },
  { id: 3, name: 'Processing', label: 'Processing' },
  { id: 4, name: 'Documents', label: 'Documents' }
];

const ProgressTracker = ({ currentStep }) => {
  return (
    <div className="w-full max-w-5xl mx-auto mb-12">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className="flex flex-col items-center relative">
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 ${
                  step.id === currentStep
                    ? 'bg-slate-100 text-slate-800 ring-4 ring-slate-300'
                    : step.id < currentStep
                    ? 'bg-slate-700 text-white'
                    : 'bg-slate-600 text-slate-300'
                }`}
              >
                {step.id < currentStep ? (
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  step.id
                )}
              </div>
              <span
                className={`mt-3 text-sm font-medium ${
                  step.id === currentStep ? 'text-slate-100' : 'text-slate-400'
                }`}
              >
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className="flex-1 h-1 mx-4 relative top-[-18px]">
                <div
                  className={`h-full rounded ${
                    step.id < currentStep ? 'bg-slate-700' : 'bg-slate-600'
                  }`}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ProgressTracker;
